import styled from 'styled-components'
import variablesApplicationConfig from '../../variables'

const PagesLayoutContainer = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: start;
  flex-direction: column;

  animation: all 0.6s ease-in-out;

  svg {
    &.svg-trail-background-svg {
      width: 100% !important;
    }
  }
`

const CenterContainer = styled.div`
  width: 100%;
  max-width: var(--max-width-section);

  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;

  .top-header {
    width: 100%;
    max-width: var(--max-width-section);
    height: 200px;

    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: center;

    margin-top: 40px;
    border-radius: 30px;

    padding-left: 100px;

    color: white;
    background-color: var(--primary-color);

    h1 {
      margin-bottom: 10px;
    }

    ::selection {
      color: var(--primary-color);
      background: white;
    }
  }

  .center-content {
    width: 100%;
    max-width: var(--max-width-section);
    padding: 0px 100px;

    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: center;

    margin-top: 20px;
  }
  @media (max-width: ${() => variablesApplicationConfig.desktopBreakpoint}px) {
    padding: 0px 30px;
  }
  @media (max-width: ${() => variablesApplicationConfig.mobileBreakpoint}px) {
    padding: 0px 30px;

    .top-header {
      padding-left: 30px;
      padding-right: 30px;
    }
    .center-content {
      padding: 0px 30px;
    }
  }
`

export { PagesLayoutContainer, CenterContainer }
